<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import NewsletterBar from '@/components/public/NewsletterBar.vue';

// Port van common/components/Footer.vue uit ui-v1.
const store = useStore();

const app = computed(() => store.state.app || {});
const socials = computed(() => [
  { key: 'facebook', href: app.value.facebook, icon: 'fab fa-facebook', klass: 'text-facebook' },
  { key: 'x', href: app.value.x, icon: 'fab fa-x-twitter', klass: '' },
  { key: 'instagram', href: app.value.instagram, icon: 'fab fa-instagram', klass: 'text-instagram' },
  { key: 'linkedin', href: app.value.linkedin, icon: 'fab fa-linkedin-in', klass: 'text-linkedin' },
].filter((item) => Boolean(item.href)));

const links = [
  { key: 'about', label: 'phrase.about_us', href: 'https://commercialreview.nl/over-ons/' },
  { key: 'privacy', label: 'word.privacy_statement', href: 'https://commercialreview.nl/privacystatement/' },
  { key: 'terms', label: 'word.terms', href: 'https://commercialreview.nl/voorwaarden/' },
  { key: 'contact', label: 'word.contact', href: 'https://commercialreview.nl/contact/' },
];
</script>

<template>
  <div>
    <newsletter-bar/>

    <nav class="public-footer">
      <div class="container-fluid d-flex flex-wrap justify-content-between text-center pb-3">
        <div class="pt-3">
          <span class="me-2">{{ app.name }} {{ app.version }}</span>
          ©
          <a
            v-for="social in socials"
            :key="social.key"
            class="ms-2"
            target="_blank"
            rel="noopener"
            :href="social.href"
            :aria-label="social.key"
          >
            <i :class="[social.icon, social.klass]"></i>
          </a>
        </div>

        <div>
          <a
            v-for="link in links"
            :key="link.key"
            class="public-footer-link pt-3 ms-4"
            target="_blank"
            rel="noopener"
            :href="link.href"
          >{{ $t(link.label) }}</a>
        </div>
      </div>
    </nav>
  </div>
</template>

<style scoped>
.public-footer {
  margin-top: auto;
  padding: 0 1rem;
}

.public-footer-link {
  display: inline-block;
  text-decoration: none;
}

.public-footer-link:hover {
  text-decoration: underline;
}

.text-facebook {
  color: #3B5998;
}

.text-instagram {
  color: #8134AF;
}

.text-linkedin {
  color: #006dac;
}
</style>
